// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1RmWH","sendOtp":"AuthorizeToLogin_sendOtp__2w9vb"};